import React from 'react';
import { LiquidityMiningPoolList } from '../../../components/LiquidityMiningPoolList';
import { LiquidityMiningPool } from '../../../components/LiquidityMiningPool';

export const ScheduledPools: React.FC = () => {
  return (
    <LiquidityMiningPoolList
      title="Scheduled pools"
      subTitle="List of scheduled pools (new pools can take a few minutes to show up here)"
      filter={(pool: LiquidityMiningPool): boolean => {
        return pool.start > new Date();
      }}
    />
  );
};
